<app-main-menu></app-main-menu>
<div class="publish-watch-container">
  <div class="form-container">
    <form [formGroup]="watchForm">
      <!-- Watch Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Watch Name</mat-label>
        <input matInput formControlName="name" placeholder="Enter watch name" required />
        <mat-error *ngIf="watchForm.get('name')?.invalid && watchForm.get('name')?.touched">
          {{ getErrorMessage('name') }}
        </mat-error>
      </mat-form-field>

      <!-- Brand (Autocomplete) -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Brand</mat-label>
        <input matInput formControlName="brand" [matAutocomplete]="auto" placeholder="Search brand" />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onBrandSelected($event)">
          <mat-option *ngFor="let brand of filteredBrands$ | async" [value]="brand.name">
            {{ brand.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="watchForm.get('brand')?.invalid && watchForm.get('brand')?.touched">
          Brand is required.
        </mat-error>
      </mat-form-field>

      <!-- Condition -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Condition</mat-label>
        <mat-select formControlName="watchCondition" required>
          <mat-option value="NEW">New</mat-option>
          <mat-option value="USED">Used</mat-option>
        </mat-select>
        <mat-error *ngIf="watchForm.get('watchCondition')?.invalid && watchForm.get('watchCondition')?.touched">
          Condition is required.
        </mat-error>
      </mat-form-field>

      <!-- Price -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Price</mat-label>
        <input matInput type="number" formControlName="price" placeholder="Enter price" required />
        <mat-error *ngIf="watchForm.get('price')?.invalid && watchForm.get('price')?.touched">
          {{ getErrorMessage('price') }}
        </mat-error>
      </mat-form-field>

      <!-- Description -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Description</mat-label>
        <textarea matInput formControlName="description" rows="4" placeholder="Enter description"></textarea>
      </mat-form-field>
    </form>
  </div>

  <div class="actions-container">
    <!-- Publish Button -->
    <button mat-flat-button color="primary" class="publish-button" [disabled]="watchForm.invalid" (click)="onSubmit()">
      Publish
    </button>

    <!-- Photos Grid -->
    <div class="photos-grid">
      <div *ngFor="let photo of photos; let i = index" class="photo-item">
        <img [src]="photo" alt="Watch Photo" />
        <button mat-icon-button class="close-button" (click)="removePhoto(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Upload Photos Button -->
    <input type="file" (change)="onFileSelected($event)" multiple accept="image/png, image/jpeg" hidden #fileInput />
    <button mat-flat-button color="accent" class="upload-button" (click)="openFileSelector()">
      Upload Photos
    </button>
  </div>
</div>
